import script from "./ProductLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProductLayout.vue?vue&type=style&index=0&id=45e3aa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e3aa2e"]])

export default __exports__